import axios from '../api/axios'

export default {
    categoryList({callback}){
        axios.get(`/oa/company/benefits/categoryList`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    benefitslist({params, callback}){
        let url = `/oa/company/benefits/list?pageNum=${params.page}&pageSize=15`
        if (params.benefitsCategoryId)
            url += `&benefitsCategoryId=${params.benefitsCategoryId}`
        axios.get(url, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/benefits.js